module.exports = __webpack_public_path__ + "static/media/everdays-black-text.1af3ef23.svg";